/* HEILMANN HOME · Kurv
   Alt indhold kommer fra Shopify: vi kalder /cart/add.js og /cart/change.js og
   henter derefter sektionen igen via Section Rendering API. Ingen kurv-state i
   JS — saa kan visningen ikke komme ud af trit med den rigtige kurv. */
(function () {
  var SEKTION = 'hh-kurv-drawer';
  var drawer = document.getElementById('hh-kurv');
  if (!drawer) return;

  var overlay = document.querySelector('[data-hh-kurv-overlay]');
  /* Kurv-siden findes kun paa /cart. Den bruger de SAMME data-hh-antal-knapper
     som drawer'en, saa der er ikke to saet logik at holde i trit. */
  var side = document.getElementById('hh-kurv-side');
  var sidstFokus = null;
  var henter = false;

  /* ---------- aabn / luk ---------- */
  function fokusbare() {
    return drawer.querySelectorAll(
      'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'
    );
  }

  function aabn() {
    if (drawer.classList.contains('is-aaben')) return;
    sidstFokus = document.activeElement;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    /* to frames, saa browseren naar at male udgangspunktet foer transitionen */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-aaben');
        if (overlay) overlay.classList.add('is-aaben');
      });
    });
    document.body.style.overflow = 'hidden';
    var f = fokusbare();
    if (f.length) f[0].focus();
  }

  function luk() {
    if (!drawer.classList.contains('is-aaben')) return;
    drawer.classList.remove('is-aaben');
    if (overlay) overlay.classList.remove('is-aaben');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-aaben')) {
        drawer.hidden = true;
        if (overlay) overlay.hidden = true;
      }
    }, 500);
    if (sidstFokus && sidstFokus.focus) sidstFokus.focus();
  }

  /* ---------- opdater visning ---------- */
  function opdaterTaeller(antal) {
    document.querySelectorAll('[data-hh-kurv-taeller]').forEach(function (el) {
      el.textContent = antal;
      el.hidden = antal < 1;
    });
  }

  function genindlaes() {
    return fetch(window.Shopify.routes.root + '?sections=' + SEKTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SEKTION];
        if (!html) return;
        var ny = new DOMParser().parseFromString(html, 'text/html').getElementById('hh-kurv');
        if (!ny) return;

        var varAaben = drawer.classList.contains('is-aaben');
        drawer.querySelector('.hh-drawer__top').replaceWith(ny.querySelector('.hh-drawer__top'));
        drawer.querySelector('.hh-drawer__body').replaceWith(ny.querySelector('.hh-drawer__body'));

        var gammelBund = drawer.querySelector('.hh-kurv__bund');
        var nyBund = ny.querySelector('.hh-kurv__bund');
        if (gammelBund && nyBund) gammelBund.replaceWith(nyBund);
        else if (gammelBund) gammelBund.remove();
        else if (nyBund) drawer.appendChild(nyBund);

        drawer.dataset.antal = ny.dataset.antal;
        opdaterTaeller(parseInt(ny.dataset.antal, 10) || 0);
        if (varAaben) drawer.classList.add('is-aaben');
        /* Beholderen er lige blevet byttet ud. Kaldes her, saa ALLE veje til
           en opdateret kurv ogsaa opdaterer forslagene - ikke kun dem, hvor
           jeg huskede at skrive det. */
        krydssalg();
      });
  }

  /* Hele sektionen hentes igen og byttes ud — saa kommer fragtbjaelke,
     opsummering, antal og tom-tilstand fra Shopify og kan ikke komme ud af
     trit med den rigtige kurv. */
  function genindlaesSide() {
    if (!side) return Promise.resolve();
    var id = side.getAttribute('data-hh-sektion');
    if (!id) return Promise.resolve();
    return fetch(window.Shopify.routes.root + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id];
        if (!html) return;
        var ny = new DOMParser().parseFromString(html, 'text/html').getElementById('hh-kurv-side');
        if (!ny) return;
        side.replaceWith(ny);
        side = ny;
        krydssalg();
      });
  }

  /* ---------- krydssalg ----------
     84 % af ordrerne har kun een varelinje. Hver ekstra vare er 205 kr i
     bidrag, som ikke koster en annoncekrone. Forslagene hentes fra Shopifys
     egen anbefalings-rute, saa der ikke skal vedligeholdes lister.
     Svaret caches pr. froe-produkt: aabner man kurven fem gange, hentes det
     een gang. */
  var krydsCache = {};

  function krydssalg() {
    var pladser = document.querySelectorAll('[data-hh-kryds]');
    if (!pladser.length) return;

    pladser.forEach(function (plads) {
      var froe = plads.getAttribute('data-froe');
      if (!froe) return;
      /* Noeglen skal ogsaa kende kurvens indhold. Uden antallet blev en vare,
         man lige havde lagt i, ved med at staa paa forslagslisten. */
      var noegle = froe + ':' + (plads.getAttribute('data-antal') || '');
      if (plads.dataset.hentet === noegle) return;
      plads.dataset.hentet = noegle;

      if (krydsCache[noegle]) { plads.innerHTML = krydsCache[noegle]; return; }

      /* Foerst "complementary" = det tilbehoer, der er valgt i Search &
         Discovery (fx lys til lyshuse). Har varen intet valgt tilbehoer,
         falder vi tilbage til "related" (lignende varer, billigste foerst). */
      function hent(intent) {
        var url = window.Shopify.routes.root + 'recommendations/products'
                + '?section_id=hh-krydssalg&limit=8&intent=' + intent + '&product_id=' + encodeURIComponent(froe);
        return fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hh-kryds-indhold]');
          });
      }

      hent('complementary')
        .then(function (boks) {
          if (boks && boks.querySelector('a')) return boks;
          return hent('related');
        })
        .then(function (boks) {
          if (!boks) return;
          krydsCache[noegle] = boks.innerHTML;
          /* Beholderen kan vaere byttet ud, mens vi ventede. */
          document.querySelectorAll('[data-hh-kryds][data-froe="' + froe + '"]')
            .forEach(function (p) { p.innerHTML = boks.innerHTML; });
        })
        .catch(function () { plads.dataset.hentet = ''; });
    });
  }

  function visBesked(html) {
    var boks = drawer.querySelector('[data-hh-kurv-besked]');
    if (!boks) return;
    boks.innerHTML = html;
    boks.hidden = false;
  }

  /* ---------- handlinger ---------- */
  function skiftAntal(noegle, vaerdi, linje) {
    if (henter) return;
    henter = true;
    if (linje) linje.classList.add('er-optaget');
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: noegle, quantity: vaerdi })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return Promise.all([genindlaes(), genindlaesSide()]); })
      .catch(function () {
        if (linje) linje.classList.remove('er-optaget');
      })
      .finally(function () { henter = false; });
  }

  function laegIKurv(form, knap) {
    if (henter) return;
    henter = true;
    if (knap) knap.setAttribute('aria-busy', 'true');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (svar) {
        return genindlaes().then(function () {
          if (!svar.ok) {
            /* Typisk en unika-vare, der blev solgt imens */
            visBesked('<b>Ups – den kunne ikke lægges i kurven.</b> ' +
              (svar.d && svar.d.description ? svar.d.description : 'Prøv igen, eller se lignende fund.'));
          }
          aabn();
        });
      })
      .catch(function () { window.location.href = window.Shopify.routes.root + 'cart'; })
      .finally(function () {
        henter = false;
        if (knap) knap.removeAttribute('aria-busy');
      });
  }

  /* ---------- lyttere ---------- */
  document.addEventListener('click', function (e) {
    var aabner = e.target.closest('[data-hh-aabn-kurv]');
    if (aabner) { e.preventDefault(); aabn(); return; }

    if (e.target.closest('[data-hh-luk]') && drawer.contains(e.target)) { luk(); return; }

    var antal = e.target.closest('[data-hh-antal]');
    if (antal && (drawer.contains(antal) || (side && side.contains(antal)))) {
      e.preventDefault();
      skiftAntal(antal.getAttribute('data-hh-antal'),
                 parseInt(antal.getAttribute('data-hh-vaerdi'), 10),
                 antal.closest('.hh-kurv__linje'));
    }
  });

  /* naar kurven aabnes, og ved sideindlaesning paa /cart */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hh-aabn-kurv]')) setTimeout(krydssalg, 60);
  });
  krydssalg();

  if (overlay) overlay.addEventListener('click', luk);

  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-aaben')) return;
    if (e.key === 'Escape') { luk(); return; }
    if (e.key !== 'Tab') return;
    var f = fokusbare();
    if (!f.length) return;
    var foerste = f[0], sidste = f[f.length - 1];
    if (e.shiftKey && document.activeElement === foerste) { e.preventDefault(); sidste.focus(); }
    else if (!e.shiftKey && document.activeElement === sidste) { e.preventDefault(); foerste.focus(); }
  });

  /* Alle "læg i kurv"-formularer uden for produktsiden gaar gennem drawer'en */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    laegIKurv(form, form.querySelector('[type=submit]'));
  });
})();
